(function(){
     'use strict';

     angular
        .module('appback')
        .factory('AnaliticalabService', AnaliticalabService);

    AnaliticalabService.$inject = ['$http'];

    function AnaliticalabService($http){

        var service= {
           getFacturacionAnual:getFacturacionAnual,
           getFacturacionCompra:getFacturacionCompra,
           getPeticionesLinea:getPeticionesLinea,
           getPrecioCategoria:getPrecioCategoria,
           getValidadores:getValidadores,
           getSeguimientolab:getSeguimientolab,
           getSeguimientocat:getSeguimientocat,
           getInfoAnalitica:getInfoAnalitica,
           getFacturacionClientes:getFacturacionClientes

        };

        return service;

        

        function getValidadores(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getvalidadores', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

         function getInfoAnalitica(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getinfoanalitica', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        

        function getSeguimientocat(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getseguimientocat', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getSeguimientolab(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getseguimientolab', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getPeticionesLinea(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getnumeropet', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getPrecioCategoria(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getpreciocat', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
 		function getFacturacionAnual(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getfacturacionanual', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getFacturacionCompra(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getfacturaciongrupocompra', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getFacturacionClientes(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/analiticalab/getfacturacionclientes', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        

      
    }
})();